module.exports = __webpack_public_path__ + "img/btn-edit-bm.fa972183.png";